import { axiosGet } from "../../Helpers";

export const loadMinors = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("lookup/getLookupByType/minor");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
